import { TileType, type Layout } from '../../data/maze-data'
export type ReefEdge = 'north' | 'east' | 'south' | 'west'
export interface ReefCell { row: number; col: number; edges: ReefEdge[] }
/** A visual skin of the authoritative collision layout; interior wall faces are omitted. */
export function reefSurfaceCells(layout: Layout): ReefCell[] {
  const cells: ReefCell[] = []
  const neighbors: [ReefEdge, number, number][] = [['north',-1,0],['east',0,1],['south',1,0],['west',0,-1]]
  for (let row=0;row<layout.length;row++) for(let col=0;col<layout[row].length;col++) {
    if(layout[row][col]!==TileType.Wall) continue
    cells.push({row,col,edges:neighbors.filter(([,dr,dc])=>layout[row+dr]?.[col+dc]!==TileType.Wall).map(([edge])=>edge)})
  }
  return cells
}
